/**
 * Base class for all notification types.
 *
 * Each subclass represents a distinct backend event (e.g. user_import_complete)
 * and knows how to resolve its own icon and target route.
 *
 * To add a new notification type:
 *   1. Create a subclass in this directory.
 *   2. Override `icon` and `resolveRoute(notification)`.
 *   3. Register it in notificationTypeRegistry.js.
 */
export default class NotificationType {
  /** FontAwesome icon class shown next to the notification. */
  get icon() {
    return 'fa-solid fa-bell';
  }

  /**
   * Returns a vue-router route location object for this notification,
   * or null if the notification has no navigable target.
   *
   * @param {Object} notification - The notification payload from the API/ActionCable.
   * @returns {{ name: string, params?: Object } | null}
   */
  resolveRoute(_notification) {
    return null;
  }
}
